"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreReportViewer = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../../../common");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const pdfjsLib = __importStar(require("pdfjs-dist/webpack"));
const THUMBNAIL_SCALE = 0.18;
const ZOOM_PRESETS = [25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200];
const ScoreReportViewerStyled = styled_components_1.default.div `
	${props => props.$isStudent ? `
		width: 100%;
		height: 100%;
	` : `
		width: calc(100% + 40px);
		height: calc(100% + 48px);
		margin: -24px -20px;
	`}
	background: #2f2f2f;
	display: flex;
	flex-direction: column;
	color: #ffffff;
	min-height: 0;

	.viewer-toolbar {
		height: 54px;
		background: #3a3a3a;
		display: flex;
		align-items: center;
		padding: 0 14px;
		gap: 12px;
		flex-shrink: 0;
		justify-content: space-between;
	}

	.toolbar-divider {
		width: 1px;
		height: 28px;
		background: rgba(255, 255, 255, 0.18);
		flex-shrink: 0;
	}

	.toolbar-title {
		font-size: 14px;
		font-weight: 400;
		line-height: 1.5;
		color: #ffffff;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		max-width: 280px;
		min-height: 32px;
		align-content: center;
	}

	.toolbar-page {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.toolbar-page-input {
		height: 30px;
		min-width: 54px;
		padding: 0 8px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		background: #222222;
		color: #ffffff;
		font-size: 14px;
		font-weight: 400;
		text-align: center;
		line-height: 30px;
		box-sizing: border-box;
	}

	.toolbar-page-input {
		width: 48px;
		outline: none;
	}

	.toolbar-page-total {
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		white-space: nowrap;
	}

	.toolbar-spacer {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.icon-button {
		border: 0;
		background: transparent;
		color: #ffffff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		padding: 0;
	}

	.icon-button:disabled {
		opacity: 0.4;
		cursor: default;
	}

.icon-button {
		width: 32px;
		height: 32px;
		border-radius: 50%;
	}

	.icon-button:hover:not(:disabled) {
		background: rgba(255, 255, 255, 0.08);
	}

	.sidebar-toggle {
		width: 32px;
		height: 32px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 4px;
	}

	.sidebar-toggle span {
		display: block;
		width: 18px;
		height: 2px;
		background: #ffffff;
		border-radius: 999px;
	}

	.toolbar-action-group {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.toolbar-zoom {
		display: flex;
		align-items: center;
		gap: 2px;
	}

	.toolbar-zoom-label {
		font-size: 13px;
		font-weight: 400;
		color: #ffffff;
		min-width: 42px;
		text-align: center;
		user-select: none;
	}

	.viewer-shell {
		display: flex;
		flex: 1;
		min-height: 0;
	}

	.viewer-sidebar {
		width: ${({ $showSidebar, $isDesktop }) => $showSidebar && $isDesktop ? '176px' : '0'};
		background: #2b2b2b;
		overflow: hidden;
		transition: width 0.2s ease;
		border-right: ${({ $showSidebar, $isDesktop }) => $showSidebar && $isDesktop ? '1px solid rgba(255,255,255,0.08)' : '0'};
	}

	.sidebar-scroll {
		height: 100%;
		overflow-y: auto;
		padding: 18px 14px 24px;
		box-sizing: border-box;
	}

	.thumbnail-button {
		width: 100%;
		border: 0;
		background: transparent;
		color: #ffffff;
		cursor: pointer;
		padding: 8px 8px 14px;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 10px;
	}

	.thumbnail-button.active {
		background: rgba(122, 173, 255, 0.16);
	}

	.thumbnail-canvas {
		background: #ffffff;
		box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.08);
		max-width: 100%;
	}

	.thumbnail-label {
		font-size: 15px;
		line-height: 1;
		color: rgba(255, 255, 255, 0.92);
	}

	.viewer-main {
		flex: 1;
		min-width: 0;
		min-height: 0;
		overflow: hidden;
		background: #3b3b3b;
		display: flex;
		flex-direction: column;
	}

	.viewer-scroll {
		flex: 1;
		overflow: auto;
		padding: 18px;
		box-sizing: border-box;
	}

	.page-stack {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 18px;
		min-height: 100%;
	}

	.page-card {
		background: #ffffff;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.28);
		position: relative;
	}

	.page-canvas {
		display: block;
		background: #ffffff;
	}

	.loading-state,
	.error-state,
	.empty-state {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 16px;
		color: rgba(255, 255, 255, 0.92);
		padding: 24px;
		text-align: center;
	}

	@media (max-width: 1399px) {
		${props => !props.$isStudent && `
			width: calc(100% + 40px);
			height: calc(100% + 48px);
		`}

		.viewer-toolbar {
			padding: 0 10px;
			gap: 0px;
			flex-wrap: wrap;
			height: auto;
			min-height: 54px;
		}

		.toolbar-title {
			max-width: 180px;
		}

		.viewer-scroll {
			padding: 14px;
		}
	}

	@media (max-width: 767px) {
		.toolbar-title {
			max-width: 150px;
		}

		.toolbar-page-input {
			min-width: 44px;
		}
	}
`;
const formatTitleFromFilename = (filename) => {
    if (!filename)
        return 'score-report';
    return filename.replace(/\.pdf$/i, '');
};
const ActionIcon = ({ type }) => {
    if (type === 'sidebar') {
        return (react_1.default.createElement("div", { className: "sidebar-toggle", "aria-hidden": "true" },
            react_1.default.createElement("span", null),
            react_1.default.createElement("span", null),
            react_1.default.createElement("span", null)));
    }
    return (react_1.default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 24 24", fill: "none", "aria-hidden": "true" },
        react_1.default.createElement("path", { d: "M7 8V4H17V8", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M7 17H5C4.44772 17 4 16.5523 4 16V11C4 10.4477 4.44772 10 5 10H19C19.5523 10 20 10.4477 20 11V16C20 16.5523 19.5523 17 19 17H17", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("path", { d: "M7 14H17V20H7V14Z", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }),
        react_1.default.createElement("circle", { cx: "17.5", cy: "12.5", r: "0.9", fill: "currentColor" })));
};
exports.ScoreReportViewer = react_1.default.memo(({ pdfData, filename, title, onDownload, isStudent = false, externalLoading = false, externalError = '', }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    const [pdfDocument, setPdfDocument] = (0, react_1.useState)(null);
    const [pageMeta, setPageMeta] = (0, react_1.useState)([]);
    const [pageCount, setPageCount] = (0, react_1.useState)(0);
    const [pageInput, setPageInput] = (0, react_1.useState)('1');
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [showSidebar, setShowSidebar] = (0, react_1.useState)(!isMobile);
    const [containerWidth, setContainerWidth] = (0, react_1.useState)(0);
    const [error, setError] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [zoom, setZoom] = (0, react_1.useState)(100);
    const zoomIn = (0, react_1.useCallback)(() => {
        setZoom(prev => {
            const next = ZOOM_PRESETS.find(p => p > prev);
            return next !== undefined ? next : prev;
        });
    }, []);
    const zoomOut = (0, react_1.useCallback)(() => {
        setZoom(prev => {
            const next = [...ZOOM_PRESETS].reverse().find(p => p < prev);
            return next !== undefined ? next : prev;
        });
    }, []);
    const viewerScrollRef = (0, react_1.useRef)(null);
    const pageCanvasRefs = (0, react_1.useRef)([]);
    const thumbCanvasRefs = (0, react_1.useRef)([]);
    const pageWrapperRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        setShowSidebar(!isMobile);
    }, [isMobile]);
    (0, react_1.useEffect)(() => {
        if (!pdfData) {
            setPdfDocument(null);
            setPageMeta([]);
            setPageCount(0);
            setCurrentPage(1);
            setPageInput('1');
            return;
        }
        let isMounted = true;
        const loadingTask = pdfjsLib.getDocument({
            data: pdfData,
            isEvalSupported: false,
        });
        setIsLoading(true);
        setError('');
        setPdfDocument(null);
        setPageMeta([]);
        setPageCount(0);
        setCurrentPage(1);
        setPageInput('1');
        setZoom(100);
        loadingTask.promise
            .then(async (documentProxy) => {
            if (!isMounted)
                return;
            const firstPage = await documentProxy.getPage(1);
            const firstViewport = firstPage.getViewport({ scale: 1 });
            const nextPageMeta = Array.from({ length: documentProxy.numPages }, (_, index) => ({
                index: index + 1,
                width: firstViewport.width,
                height: firstViewport.height,
            }));
            if (!isMounted)
                return;
            setPdfDocument(documentProxy);
            setPageMeta(nextPageMeta);
            setPageCount(documentProxy.numPages);
            setIsLoading(false);
        })
            .catch((loadError) => {
            if (!isMounted)
                return;
            setError(loadError?.message || 'PDF 문서를 불러오지 못했습니다.');
            setIsLoading(false);
        });
        return () => {
            isMounted = false;
            loadingTask.destroy();
        };
    }, [pdfData]);
    (0, react_1.useEffect)(() => {
        if (!viewerScrollRef.current)
            return undefined;
        const observer = new ResizeObserver(entries => {
            const nextWidth = entries[0]?.contentRect?.width || 0;
            setContainerWidth(nextWidth);
        });
        observer.observe(viewerScrollRef.current);
        return () => observer.disconnect();
    }, [pageCount]);
    const baseWidth = pageMeta[0]?.width || 0;
    const fitScale = (0, react_1.useMemo)(() => {
        if (!baseWidth || !containerWidth)
            return 1;
        const availableWidth = Math.max(containerWidth - 36, 120);
        return availableWidth / baseWidth;
    }, [baseWidth, containerWidth]);
    const renderScale = fitScale * (zoom / 100);
    (0, react_1.useEffect)(() => {
        if (!pdfDocument || !pageCount)
            return undefined;
        let cancelled = false;
        const activeTasks = [];
        const renderCanvas = async (pageNumber, canvas, scale) => {
            if (!canvas)
                return;
            const page = await pdfDocument.getPage(pageNumber);
            if (cancelled)
                return;
            const viewport = page.getViewport({ scale });
            const context = canvas.getContext('2d');
            if (!context)
                return;
            const ratio = window.devicePixelRatio || 1;
            canvas.width = Math.floor(viewport.width * ratio);
            canvas.height = Math.floor(viewport.height * ratio);
            canvas.style.width = `${viewport.width}px`;
            canvas.style.height = `${viewport.height}px`;
            const transform = ratio !== 1 ? [ratio, 0, 0, ratio, 0, 0] : undefined;
            const task = page.render({ canvasContext: context, viewport, transform });
            activeTasks.push(task);
            await task.promise.catch((err) => {
                if (err?.name !== 'RenderingCancelledException')
                    throw err;
            });
        };
        const renderPages = async () => {
            for (let pageNumber = 1; pageNumber <= pageCount; pageNumber += 1) {
                if (cancelled)
                    return;
                await renderCanvas(pageNumber, pageCanvasRefs.current[pageNumber - 1], renderScale);
            }
        };
        void renderPages();
        return () => {
            cancelled = true;
            activeTasks.forEach(task => { try {
                task.cancel();
            }
            catch (_) { } });
        };
    }, [pdfDocument, pageCount, renderScale]);
    (0, react_1.useEffect)(() => {
        if (!pdfDocument || !pageCount || isMobile)
            return undefined;
        let cancelled = false;
        const activeTasks = [];
        const renderThumbnails = async () => {
            for (let pageNumber = 1; pageNumber <= pageCount; pageNumber += 1) {
                if (cancelled)
                    return;
                const page = await pdfDocument.getPage(pageNumber);
                if (cancelled)
                    return;
                const canvas = thumbCanvasRefs.current[pageNumber - 1];
                if (!canvas)
                    continue;
                const viewport = page.getViewport({ scale: THUMBNAIL_SCALE });
                const context = canvas.getContext('2d');
                if (!context)
                    continue;
                const ratio = window.devicePixelRatio || 1;
                canvas.width = Math.floor(viewport.width * ratio);
                canvas.height = Math.floor(viewport.height * ratio);
                canvas.style.width = `${viewport.width}px`;
                canvas.style.height = `${viewport.height}px`;
                const transform = ratio !== 1 ? [ratio, 0, 0, ratio, 0, 0] : undefined;
                const task = page.render({ canvasContext: context, viewport, transform });
                activeTasks.push(task);
                await task.promise.catch((err) => {
                    if (err?.name !== 'RenderingCancelledException')
                        throw err;
                });
            }
        };
        void renderThumbnails();
        return () => {
            cancelled = true;
            activeTasks.forEach(task => { try {
                task.cancel();
            }
            catch (_) { } });
        };
    }, [pdfDocument, pageCount, isMobile]);
    (0, react_1.useEffect)(() => {
        const container = viewerScrollRef.current;
        if (!container || !pageCount)
            return undefined;
        const updateCurrentPage = () => {
            const containerRect = container.getBoundingClientRect();
            const containerCenter = containerRect.top + container.clientHeight / 2;
            let closestPage = 1;
            let closestDistance = Number.POSITIVE_INFINITY;
            pageWrapperRefs.current.forEach((element, index) => {
                if (!element)
                    return;
                const rect = element.getBoundingClientRect();
                const pageCenter = rect.top + rect.height / 2;
                const distance = Math.abs(pageCenter - containerCenter);
                if (distance < closestDistance) {
                    closestDistance = distance;
                    closestPage = index + 1;
                }
            });
            setCurrentPage(closestPage);
            setPageInput(String(closestPage));
        };
        updateCurrentPage();
        container.addEventListener('scroll', updateCurrentPage, { passive: true });
        window.addEventListener('resize', updateCurrentPage);
        return () => {
            container.removeEventListener('scroll', updateCurrentPage);
            window.removeEventListener('resize', updateCurrentPage);
        };
    }, [pageCount, renderScale, showSidebar, isMobile]);
    (0, react_1.useEffect)(() => {
        const el = viewerScrollRef.current;
        if (!el)
            return undefined;
        const onWheel = (e) => {
            if (!e.ctrlKey)
                return;
            e.preventDefault();
            if (e.deltaY < 0)
                zoomIn();
            else
                zoomOut();
        };
        el.addEventListener('wheel', onWheel, { passive: false });
        return () => el.removeEventListener('wheel', onWheel);
    }, [zoomIn, zoomOut, pageCount]);
    const displayedTitle = title || formatTitleFromFilename(filename);
    const scrollToPage = (pageNumber) => {
        const targetPage = pageWrapperRefs.current[pageNumber - 1];
        const container = viewerScrollRef.current;
        if (!targetPage || !container)
            return;
        targetPage.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setCurrentPage(pageNumber);
        setPageInput(String(pageNumber));
    };
    const commitPageInput = () => {
        const parsed = Number(pageInput);
        if (!Number.isFinite(parsed)) {
            setPageInput(String(currentPage));
            return;
        }
        const nextPage = Math.max(1, Math.min(pageCount || 1, Math.floor(parsed)));
        scrollToPage(nextPage);
    };
    const canShowSidebar = !isMobile && pageCount > 0;
    return (react_1.default.createElement(ScoreReportViewerStyled, { "$showSidebar": showSidebar, "$isDesktop": !isMobile, "$isStudent": isStudent },
        react_1.default.createElement("div", { className: "viewer-toolbar" },
            react_1.default.createElement("div", { className: "toolbar-spacer" },
                canShowSidebar && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("button", { type: "button", className: "icon-button", onClick: () => setShowSidebar(prev => !prev), "aria-label": "\uD398\uC774\uC9C0 \uC0AC\uC774\uB4DC\uBC14 \uD1A0\uAE00" },
                        react_1.default.createElement(ActionIcon, { type: "sidebar" })),
                    react_1.default.createElement("div", { className: "toolbar-divider" }))),
                react_1.default.createElement("div", { className: "toolbar-title", title: displayedTitle }, displayedTitle)),
            react_1.default.createElement("div", { className: "toolbar-spacer" },
                react_1.default.createElement("div", { className: "toolbar-page" },
                    react_1.default.createElement("input", { className: "toolbar-page-input", value: pageInput, onChange: event => setPageInput(event.target.value.replace(/[^0-9]/g, '')), onBlur: commitPageInput, onKeyDown: event => {
                            if (event.key === 'Enter')
                                commitPageInput();
                        }, "aria-label": "\uD604\uC7AC \uD398\uC774\uC9C0" }),
                    react_1.default.createElement("div", { className: "toolbar-page-total" },
                        "/ ",
                        pageCount || 0)),
                react_1.default.createElement("div", { className: "toolbar-divider" }),
                react_1.default.createElement("div", { className: "toolbar-zoom" },
                    react_1.default.createElement("button", { type: "button", className: "icon-button", onClick: zoomOut, disabled: zoom <= 25, "aria-label": "\uCD95\uC18C" },
                        react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "currentColor", "aria-hidden": "true" },
                            react_1.default.createElement("rect", { x: "3", y: "7", width: "10", height: "2", rx: "1" }))),
                    react_1.default.createElement("div", { className: "toolbar-zoom-label" },
                        zoom,
                        "%"),
                    react_1.default.createElement("button", { type: "button", className: "icon-button", onClick: zoomIn, disabled: zoom >= 200, "aria-label": "\uD655\uB300" },
                        react_1.default.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "currentColor", "aria-hidden": "true" },
                            react_1.default.createElement("rect", { x: "7", y: "3", width: "2", height: "10", rx: "1" }),
                            react_1.default.createElement("rect", { x: "3", y: "7", width: "10", height: "2", rx: "1" })))),
                react_1.default.createElement("div", { className: "toolbar-divider" }),
                react_1.default.createElement("div", { className: "toolbar-action-group" },
                    react_1.default.createElement("button", { type: "button", className: "icon-button", onClick: onDownload, "aria-label": "PDF \uB2E4\uC6B4\uB85C\uB4DC" },
                        react_1.default.createElement(common_1.Icon, { icon: "download", size: 18, fill: "#ffffff" }))))),
        react_1.default.createElement("div", { className: "viewer-shell" },
            canShowSidebar && (react_1.default.createElement("div", { className: "viewer-sidebar", "aria-hidden": !showSidebar },
                react_1.default.createElement("div", { className: "sidebar-scroll" }, Array.from({ length: pageCount }, (_, index) => (react_1.default.createElement("button", { type: "button", key: `thumb-${index + 1}`, className: `thumbnail-button ${currentPage === index + 1 ? 'active' : ''}`, onClick: () => scrollToPage(index + 1) },
                    react_1.default.createElement("canvas", { className: "thumbnail-canvas", ref: element => {
                            thumbCanvasRefs.current[index] = element;
                        } }),
                    react_1.default.createElement("div", { className: "thumbnail-label" }, index + 1))))))),
            react_1.default.createElement("div", { className: "viewer-main" }, externalLoading ? (react_1.default.createElement("div", { className: "loading-state" }, "\uC131\uC801\uD45C\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4.")) : externalError ? (react_1.default.createElement("div", { className: "error-state" }, externalError)) : isLoading ? (react_1.default.createElement("div", { className: "loading-state" }, "PDF\uB97C \uBD88\uB7EC\uC624\uB294 \uC911\uC785\uB2C8\uB2E4.")) : error ? (react_1.default.createElement("div", { className: "error-state" }, error)) : pageCount === 0 ? (react_1.default.createElement("div", { className: "empty-state" }, "\uD45C\uC2DC\uD560 PDF\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.")) : (react_1.default.createElement("div", { className: "viewer-scroll", ref: viewerScrollRef },
                react_1.default.createElement("div", { className: "page-stack" }, Array.from({ length: pageCount }, (_, index) => (react_1.default.createElement("div", { className: "page-card", key: `page-${index + 1}`, ref: element => {
                        pageWrapperRefs.current[index] = element;
                    } },
                    react_1.default.createElement("canvas", { className: "page-canvas", ref: element => {
                            pageCanvasRefs.current[index] = element;
                        } })))))))))));
});
